import type { NodeId } from 'web';

export enum WorkflowAppVisibility {
  Private = 'private',
  Workspace = 'workspace',
  Public = 'public',
}

export interface DraftInputOverride {
  nodeId: NodeId;
  exposed: boolean;
  order: number;
  required: boolean;
  disabled: boolean;
  label?: string;
  description?: string;
  defaultValue?: unknown;
}

export interface DraftOutputOverride {
  nodeId: NodeId;
  order: number;
  label?: string;
  description?: string;
}

export interface WorkflowAppDraftOverrides {
  inputs: DraftInputOverride[];
  outputs: DraftOutputOverride[];
}

export interface WorkflowApp {
  id: string;
  workflowId: string;
  draftOverrides: WorkflowAppDraftOverrides;
  publishedAppVersionId: string | null;
  creatorId: string;
  workspaceId: string;
  visibility: WorkflowAppVisibility;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface CreateWorkflowAppRequestDto {
  workflowId: string;
}

export interface UpdateWorkflowAppRequestDto {
  publishedAppVersionId?: string | null;
  visibility?: WorkflowAppVisibility;
  draftOverrides?: WorkflowAppDraftOverrides;
}
